import { useMutation, useQuery } from 'react-query';
import { adminNotificationController } from '../../API/notifications';

interface NotificationItem {
  id: string;
  title: string;
  description: string;
  createdAt: string;
  read: boolean;
  user?: {
    first_name: string;
    second_name: string;
    id: number;
    additionalData?: {
      company_name: string;
      usdot: string;
      number_employees: string | number;
    };
  };
  company?: {
    name: string;
    id: number;
  };
}

export const useNotifications = () => {
  return useQuery<NotificationItem[]>('notifications/list', adminNotificationController.getList, {
    refetchOnWindowFocus: false,
  });
};

export const useUnreadCount = () => {
  return useQuery<number>(
    'notifications/unread-count',
    adminNotificationController.getUnreadCount,
    {
      refetchOnWindowFocus: false,
    },
  );
};

export const useMarkAllAsRead = () => {
  return useMutation(adminNotificationController.markAllAsRead);
};

export const useMarkAsRead = () => {
  return useMutation((id: string) => adminNotificationController.markAsRead(id));
};
